module.exports = __webpack_public_path__ + "img/marmelaedchen-l557_xs.f89ee5ee.jpg";